export default __webpack_public_path__ + "static/media/Christian_Pinto_Resume.283b8953.docx";